module.exports = __webpack_public_path__ + "img/ly_icon2.16ac3b9.png";